var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_carica",
    "data-name": "icona carica",
    transform: "translate(-899.709 -124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_96",
    "data-name": "Tracciato 96",
    d: "M97.168,16.195a.724.724,0,0,1,1.024,0l2.731,2.731A.724.724,0,0,1,99.9,19.95L98.4,18.455v7.907a.724.724,0,0,1-1.448,0V18.455L95.462,19.95a.724.724,0,1,1-1.024-1.024Z",
    transform: "translate(809.028 108.018)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_97",
    "data-name": "Tracciato 97",
    d: "M29.259,154.5a.724.724,0,0,0-.724.724v5.552h-11.1v-5.552a.724.724,0,1,0-1.448,0v5.793a1.207,1.207,0,0,0,1.207,1.207H28.776a1.207,1.207,0,0,0,1.207-1.207v-5.793A.724.724,0,0,0,29.259,154.5Z",
    transform: "translate(883.726 -24.224)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoad);
export default __webpack_public_path__ + "static/media/load.42c110ce6b96d9b3b0cce1a5bad286e6.svg";
export { ForwardRef as ReactComponent };